module.exports = __webpack_public_path__ + "img/pass-word.851397cd.svg";